import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    recommendation: checkText(settings),
});

export const RecommendationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formRecommendation">
                <Form.Label>Ggfs. Empfehlung durch Mitarbeiter*in</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Name des/der Mitarbeiter*in eingeben"
                    type="text"
                    name="recommendation"
                    value={values.recommendation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.recommendation && !errors.recommendation}
                    isInvalid={touched.recommendation && errors.recommendation}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.recommendation}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};